import { HTTP } from '@/services/axios';

export async function getLibraries({filterText,filterCategory,orderCol,orderSort,page,records}){
    let result = {};
    await HTTP.get('/app/core/Library/getLibraryList.php',{
        params:{
            filterText,
            filterCategory,
            orderCol,
            orderSort,
            page,
            records
        }
    })
    .then(response => {
        console.log(response.data)
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getLibrary({libraryId}){
    let result = {};
    
    await HTTP({
        method: 'get',
        url: `/app/core/Library/getLibraryData.php?libraryId=${libraryId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getLibraryInfo({libraryId}){
    let result = {};

    await HTTP({
        method: 'get',
        url: `/app/core/Library/getLibraryInfo.php?libraryId=${libraryId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getLibraryOptions(){
    let result = [];
    
    await HTTP({
        method: 'get',
        url: '/app/core/Library/getLibraryOptions.php'
    })
    .then(response => {
        result = response.data.result;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}


export async function unlockLibrary({libraryId}){
    let result = {};

    var data = {'myRecordID':libraryId};
    
    await HTTP({
        method: 'patch',
        url: '/app/core/Library/controlLibraryUnlock.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function changeStateLibrary({recordId,state}){
    let result = {};

    var data = {'recordId':recordId,'state':state};
    
    await HTTP({
        method: 'patch',
        url: '/app/core/Library/controlLibraryChangeState.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function createLibrary({data}){
    let result = {};
  
    await HTTP({
        method: 'post',
        url: '/app/core/Library/controlLibrarySave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function saveLibrary({data}){
    let result = {};
  
    await HTTP({
        method: 'put',
        url: '/app/core/Library/controlLibrarySave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function deleteLibrary({data}){
    let result = {};

    await HTTP({
        method: 'delete',
        url: '/app/core/Library/controlLibraryDelete.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}
